import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClick: () => void
  integrationLabel: string
  blockedSubmit: boolean
}

const ReLink = ({ onClick, integrationLabel, blockedSubmit }: Props) => {
  const description = function (): string {
    if (blockedSubmit) {
      return i18n.t('payroll_integrations.sync.supplements_preview.relink.description_blocked', {
        integrationLabel: integrationLabel,
      })
    }
    return i18n.t('payroll_integrations.sync.supplements_preview.relink.description', {
      integrationLabel: integrationLabel,
    })
  }
  return (
    <Box
      paddingTop="s16"
      background="champagne400"
      borderRadius={{
        all: 'abs008',
      }}
      width="full"
      paddingX="s24"
      paddingY="s16"
      gap="s8"
    >
      <Text.Normal size="200" weight="bold">
        {i18n.t('payroll_integrations.sync.supplements_preview.relink.title', {
          integrationLabel: integrationLabel,
        })}
      </Text.Normal>
      <Text.Normal size="200" weight="medium">
        {description()}
      </Text.Normal>
      <Link.Touchable onClick={onClick}>
        <Box paddingBottom="s4">
          <Text.Normal size="200" weight="semibold" underlined>
            {i18n.t('payroll_integrations.sync.supplements_preview.relink.button', {
              integrationLabel: integrationLabel,
            })}
          </Text.Normal>
        </Box>
      </Link.Touchable>
    </Box>
  )
}

export default ReLink
